module.exports = __webpack_public_path__ + "static/media/user.9c3eb4cf.png";